export const LEGAL_CONTACT_EMAIL = 'Infocolobongo@gmail.com';
export const LEGAL_BRAND_NAME = 'ColoBongo\u2122';
// Bilingue ({ fr, en }) - choisir via LEGAL_COPYRIGHT[language] cote consommateur.
export const LEGAL_COPYRIGHT = {
  fr: '\u00A9 2026 ColoBongo\u2122. Tous droits r\u00E9serv\u00E9s.',
  en: '\u00A9 2026 ColoBongo\u2122. All rights reserved.',
};

export const LEGAL_LINK_LABELS = {
  fr: {
    privacy: 'Politique de confidentialité',
    terms: 'Conditions d’utilisation',
    refund: 'Politique de remboursement',
    cookies: 'Cookies',
    contact: 'Contact'
  },
  en: {
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    refund: 'Refund Policy',
    cookies: 'Cookies',
    contact: 'Contact'
  }
};

export const LEGAL_PAGE_CONTENT = {
  fr: {
    privacy: {
      title: 'Politique de confidentialité',
      intro:
        "Chez ColoBongo™, nous prenons soin de ta vie privée. L’app est en accès anticipé, avec une approche simple, transparente et humaine.",
      sections: [
        {
          heading: 'Données que nous pouvons collecter',
          bullets: [
            "Tes créations, seulement si tu choisis de les sauvegarder ou de les partager",
            'Des données techniques de base (cookies, mesures d’usage, diagnostics)',
            "Des données de compte nécessaires au fonctionnement (ex : email d’authentification)"
          ]
        },
        {
          heading: 'Pourquoi nous collectons ces données',
          bullets: [
            "Améliorer l’expérience ColoBongo™",
            'Comprendre ce qui fonctionne et ce qui doit être amélioré',
            "Assurer la stabilité de l’app en phase d’accès anticipé"
          ]
        },
        {
          heading: 'AI Scan : accompagnement, jamais jugement',
          text:
            "Notre AI Scan peut se tromper. Les retours sont indicatifs et servent à encourager ta progression, jamais à te juger."
        },
        {
          heading: 'Tes choix',
          bullets: [
            'Tu peux refuser les cookies non essentiels',
            'Tu peux demander la suppression de tes données',
            'Tu peux nous contacter à tout moment'
          ]
        }
      ]
    },
    terms: {
      title: "Conditions d’utilisation",
      intro:
        "Merci d’utiliser ColoBongo™. En utilisant l’app, tu acceptes ces règles simples qui protègent la Colomunauté et gardent une expérience cozy.",
      sections: [
        {
          heading: 'Usage responsable',
          bullets: [
            "Utiliser l’app de façon respectueuse et légale",
            'Ne pas publier de contenu nuisible, offensant ou trompeur',
            'Respecter les autres membres de la Colomunauté'
          ]
        },
        {
          heading: 'Service en accès anticipé',
          bullets: [
            'Certaines fonctionnalités peuvent évoluer, être modifiées ou retirées',
            'Des interruptions ponctuelles peuvent arriver pendant les améliorations',
            "Nous faisons de notre mieux pour garder l’app stable et agréable"
          ]
        },
        {
          heading: 'AI Scan : limite de responsabilité',
          text:
            'Les analyses AI sont fournies pour inspirer et guider. Elles ne constituent pas une évaluation absolue de ta valeur artistique.'
        },
        {
          heading: 'Contact et suppression',
          text:
            `Pour toute question légale, demande de suppression ou signalement : ${LEGAL_CONTACT_EMAIL}.`
        }
      ]
    },
    refund: {
      title: 'Politique de remboursement',
      intro:
        "Bongo croit en la confiance avant tout. Tu peux annuler ton abonnement Contributeur quand tu veux, et nous offrons une garantie 14 jours sans questions sur ton premier paiement.",
      sections: [
        {
          heading: 'Annulation à tout moment',
          text:
            "Tu peux annuler ton abonnement Contributeur Bongo quand tu veux, sans donner de raison, depuis ton portail client (page Soutenir, bouton Gérer mon abonnement). Ton accès Contributeur reste actif jusqu'à la fin de la période déjà payée."
        },
        {
          heading: 'Garantie 14 jours sans questions',
          text:
            `Si dans les 14 jours suivant ton premier paiement Contributeur, tu sens que ColoBongo n'est pas pour toi, écris-nous à ${LEGAL_CONTACT_EMAIL} avec ton email d'inscription. Nous te rembourserons intégralement, sans questions.`
        },
        {
          heading: 'Au-delà de 14 jours',
          text:
            "Après 14 jours, les paiements déjà effectués ne sont pas remboursables, mais tu peux annuler en quelques clics et tu garderas tes avantages jusqu'à la fin du mois ou de l'année déjà payée."
        },
        {
          heading: 'En cas de problème technique',
          text:
            "Si ColoBongo n'a pas fonctionné pendant une partie significative de ta période d'abonnement (panne, fonctionnalité indisponible), écris-nous. On regardera ensemble pour ajuster ou rembourser au prorata."
        },
        {
          heading: 'Contact',
          text:
            `Pour toute demande de remboursement ou question, écris à ${LEGAL_CONTACT_EMAIL}. Réponse sous 48h en général. Merci de soutenir ColoBongo — sans toi, l'app n'existerait pas.`
        }
      ]
    },
    cookies: {
      title: 'Politique cookies',
      intro:
        "Nous utilisons des cookies pour faire fonctionner ColoBongo™ et, avec ton accord, pour mieux comprendre l’utilisation de l’app.",
      sections: [
        {
          heading: 'Cookies essentiels',
          bullets: [
            'Nécessaires au fonctionnement (session, sécurité, préférences de base)',
            "Toujours actifs car indispensables à l’app"
          ]
        },
        {
          heading: 'Cookies non essentiels',
          bullets: [
            "Analytics et mesures d’usage pour améliorer l’expérience",
            'Actifs uniquement si tu acceptes explicitement'
          ]
        },
        {
          heading: 'Gérer ton choix',
          bullets: [
            'Tu peux accepter ou refuser au premier affichage',
            'Tu peux modifier ton choix plus tard depuis les Settings',
            'Ton choix est stocké localement sur ton appareil'
          ]
        },
        {
          heading: 'AI Scan',
          text:
            "Rappel : l’AI Scan peut se tromper. Il est là pour encourager et aider, pas pour juger."
        }
      ]
    }
  },
  en: {
    privacy: {
      title: 'Privacy Policy',
      intro:
        'At ColoBongo\u2122, we care about your privacy. The app is in early access, with a simple and transparent approach.',
      sections: [
        {
          heading: 'Data we may collect',
          bullets: [
            'Your creations, only if you choose to save or share them',
            'Basic technical data (cookies, usage metrics, diagnostics)',
            'Account data required to run the app (for example authentication email)'
          ]
        },
        {
          heading: 'Why we collect it',
          bullets: [
            'Improve the ColoBongo\u2122 experience',
            'Understand what works and what needs improvement',
            'Keep the app stable during early access'
          ]
        },
        {
          heading: 'AI Scan: guidance, never judgment',
          text:
            'Our AI Scan can make mistakes. Its feedback is indicative and meant to encourage progress, never to judge your creativity.'
        },
        {
          heading: 'Your choices',
          bullets: [
            'You can refuse non-essential cookies',
            'You can request data deletion',
            'You can contact us anytime'
          ]
        }
      ]
    },
    terms: {
      title: 'Terms of Use',
      intro:
        'Thanks for using ColoBongo\u2122. By using the app, you agree to simple rules that keep the Colomunauty safe and cozy.',
      sections: [
        {
          heading: 'Responsible use',
          bullets: [
            'Use the app in a lawful and respectful way',
            'Do not share harmful, offensive, or misleading content',
            'Respect other members of the Colomunauty'
          ]
        },
        {
          heading: 'Early access service',
          bullets: [
            'Some features may evolve, change, or be removed',
            'Short interruptions may happen during updates',
            'We do our best to keep the app stable and enjoyable'
          ]
        },
        {
          heading: 'AI Scan limitation',
          text:
            'AI feedback is provided to inspire and guide. It is not an absolute evaluation of your artistic value.'
        },
        {
          heading: 'Contact and deletion',
          text:
            `For legal questions, deletion requests, or reports: ${LEGAL_CONTACT_EMAIL}.`
        }
      ]
    },
    refund: {
      title: 'Refund Policy',
      intro:
        "Bongo believes in trust first. You can cancel your Contributor subscription anytime, and we offer a no-questions-asked 14-day guarantee on your first payment.",
      sections: [
        {
          heading: 'Cancel anytime',
          text:
            "You can cancel your Bongo Contributor subscription anytime, no questions asked, from your customer portal (Support page, Manage my subscription button). Your Contributor access stays active until the end of the period already paid."
        },
        {
          heading: '14-day no-questions-asked guarantee',
          text:
            `If within 14 days of your first Contributor payment you feel ColoBongo is not for you, email us at ${LEGAL_CONTACT_EMAIL} with your account email. We will refund you in full, no questions asked.`
        },
        {
          heading: 'After 14 days',
          text:
            "After 14 days, payments already made are non-refundable, but you can cancel in a few clicks and keep your perks until the end of the month or year already paid."
        },
        {
          heading: 'In case of technical issue',
          text:
            "If ColoBongo did not work during a significant part of your subscription period (outage, feature unavailable), email us. We will look together to adjust or refund pro rata."
        },
        {
          heading: 'Contact',
          text:
            `For any refund request or question, email ${LEGAL_CONTACT_EMAIL}. Response within 48h typically. Thanks for supporting ColoBongo - without you, the app would not exist.`
        }
      ]
    },
    cookies: {
      title: 'Cookies Policy',
      intro:
        'We use cookies to run ColoBongo\u2122 and, with your consent, to better understand app usage.',
      sections: [
        {
          heading: 'Essential cookies',
          bullets: [
            'Required for core app features (session, security, basic preferences)',
            'Always active because they are necessary'
          ]
        },
        {
          heading: 'Non-essential cookies',
          bullets: [
            'Analytics and usage measurement to improve the experience',
            'Enabled only if you explicitly accept'
          ]
        },
        {
          heading: 'Managing your choice',
          bullets: [
            'You can accept or reject on first display',
            'You can change your choice later in Settings',
            'Your choice is stored locally on your device'
          ]
        },
        {
          heading: 'AI Scan',
          text:
            'Reminder: AI Scan can be wrong. It is designed to encourage and help, not to judge.'
        }
      ]
    }
  }
};
